// Libraries
import {View} from 'react-big-calendar';

import Datetime, {MomentType} from '@supermove/utils/src/Datetime';

// Supermove

export enum USER_CALENDAR_VIEW_TYPE {
  MONTH = 'MONTH',
  WEEK = 'WEEK',
  WORK_WEEK = 'WORK_WEEK',
  DAY = 'DAY',
  AGENDA = 'AGENDA',
}

export const toBigCalendarView = (viewType: USER_CALENDAR_VIEW_TYPE): View => {
  switch (viewType) {
    case USER_CALENDAR_VIEW_TYPE.MONTH:
      return 'month';
    case USER_CALENDAR_VIEW_TYPE.WEEK:
      return 'week';
    case USER_CALENDAR_VIEW_TYPE.WORK_WEEK:
      return 'work_week';
    case USER_CALENDAR_VIEW_TYPE.DAY:
      return 'day';
    case USER_CALENDAR_VIEW_TYPE.AGENDA:
      return 'agenda';
    default:
      return 'month';
  }
};

export const toUserCalendarViewType = (view: View): USER_CALENDAR_VIEW_TYPE => {
  switch (view) {
    case 'month':
      return USER_CALENDAR_VIEW_TYPE.MONTH;
    case 'week':
      return USER_CALENDAR_VIEW_TYPE.WEEK;
    case 'work_week':
      return USER_CALENDAR_VIEW_TYPE.WORK_WEEK;
    case 'day':
      return USER_CALENDAR_VIEW_TYPE.DAY;
    case 'agenda':
      return USER_CALENDAR_VIEW_TYPE.AGENDA;
    default:
      return USER_CALENDAR_VIEW_TYPE.MONTH;
  }
};

export const getTimeRangeForViewType = (
  viewType: USER_CALENDAR_VIEW_TYPE,
  baseDate: MomentType = Datetime.now,
): {startDate: MomentType; endDate: MomentType} => {
  switch (viewType) {
    case USER_CALENDAR_VIEW_TYPE.MONTH:
      return {
        startDate: baseDate.clone().startOf('month'),
        endDate: baseDate.clone().endOf('month'),
      };
    case USER_CALENDAR_VIEW_TYPE.WEEK:
      return {
        startDate: baseDate.clone().startOf('week'),
        endDate: baseDate.clone().endOf('week'),
      };
    case USER_CALENDAR_VIEW_TYPE.WORK_WEEK:
      return {
        startDate: baseDate.clone().startOf('week').add(1, 'day'), // Monday
        endDate: baseDate.clone().startOf('week').add(5, 'day').endOf('day'), // Friday
      };
    case USER_CALENDAR_VIEW_TYPE.DAY:
      return {
        startDate: baseDate.clone().startOf('day'),
        endDate: baseDate.clone().endOf('day'),
      };
    case USER_CALENDAR_VIEW_TYPE.AGENDA:
    default:
      return {
        startDate: baseDate.clone(),
        endDate: baseDate.clone().add(30, 'days'),
      };
  }
};
